import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'pc-module-sub-title-2',
  props: {
    innerText: { default: '大标题' },
    index: {}
  },
  setup(__props: any) {

const props = __props;

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="40" viewBox="0 0 1024 42">
  <g id="xiaobiao2" transform="translate(0 -3)">
    <g id="矩形_2759" data-name="矩形 2759" transform="translate(67 3)" fill="#fff" stroke="var(--theme-color-1)" stroke-width="1">
      <rect width="265" height="42" stroke="none"/>
      <rect x="0.5" y="0.5" width="264" height="41" fill="none"/>
    </g>
    <rect id="矩形_2760" data-name="矩形 2760" width="9" height="42" transform="translate(68 3)" fill="var(--theme-color-1)"/>
    <line id="直线_682" data-name="直线 682" x2="70" transform="translate(5.5 24.5)" fill="none" stroke="var(--theme-color-1)" stroke-width="2"/>
    <circle id="椭圆_800" data-name="椭圆 800" cx="5.5" cy="5.5" r="5.5" transform="translate(0 19)" fill="var(--theme-color-1)"/>
    <text id="执行人男性年龄分布" transform="translate(95.355 31)" fill="#222" font-size="22" font-weight="600"><tspan x="0" y="0">${props.innerText}</tspan></text>
  </g>
</svg>
`;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "svg-block",
    innerHTML: svg
  }))
}
}

})